<template>
    <rkm-content>
        <rkm-content-header :title="$route.meta.title" />

        <rkm-content-body>
            <rkm-container>
                <List />
            </rkm-container>
        </rkm-content-body>
    </rkm-content>
</template>

<script>
// Components.
import List from '@/components/cadastro/modulo/List'

export default {
    components: {List},
}
</script>